import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as AssistantGlyph } from "../../assets/cchat-assistant-icon.svg";

// Uses the same currentColor and sizing as the other sidebar icons.
const CchatAssistantIcon = React.forwardRef(function CchatAssistantIcon(
  { titleAccess, ...props },
  ref
) {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      component={AssistantGlyph}
      viewBox="0 0 32 32"
      title={titleAccess}
      titleAccess={titleAccess}
    />
  );
});

export default CchatAssistantIcon;
